(function($) {

	$.fn.initNabizime1 = function() {

		var _this = this;

		_this.find('.texts>*').addClass('preparing').waypoint(function() {
			$(this.element).removeClass('preparing');
		}, {
			offset: function() {
				return Waypoint.viewportHeight() - ($(this.element).height() * 0.75);
			}
		});

		window.setTimeout(function() {
			_this.addClass('animated');
		}, 50);

		return this;

	}

})(jQuery);
